import React from 'react';
import normalizeVariables from '../../graphql/schema/normalizeVariables';
import getIn from '../../components/connectedForm/utils/getIn';
import { serviceActions } from '../../state/modules/service';
import { getActionProps } from '../../utils/getActionProps';

export function alertError(title, message, type, dispatch) {
  dispatch(serviceActions.genericAlert(title, message, type));
}

/**
 * Get mutation props for a new Document.
 * @param defaultMutationProps - Set of props similar across all documents (Output type, printer, etc..)
 * @returns {{clientMutationId: string, reportParameters: {emailFrom: string, emailToList: *, template: {id: *}, outputType: *, printerId: *, jasperValues: {message: string}}, salesOrder}}
 */
export function getMutationProps(state, props, defaultMutationProps, valueKey = 'purchaseOrder') {
  //Sanitize the purchase order - This is because we have the mutated version from purchaseOrderUpdate.
  let entityValue = normalizeVariables(getIn(props, 'values'));
  if (entityValue.entityMetaData) delete entityValue.entityMetaData;
  defaultMutationProps[valueKey] = entityValue;

  return defaultMutationProps;
}

export function getRangeMutationProps(state, props, defaultMutationProps, type, workspaceUrl) {
  let actionProps =
    (props.overrideActionProps && props.overrideActionProps()) ||
    getActionProps(props, type, workspaceUrl || 'Purchasing/Order/Workspace');

  return {
    ...defaultMutationProps,
    ...actionProps,
    reportParameters: {
      ...defaultMutationProps.reportParameters,
      overrideOutput: state.overrideOutput,
      overrideTemplate: state.overrideTemplate,
    },
  };
}
